const AWS = require('aws-sdk/global');

AWS.Lambda = require('aws-sdk/clients/lambda');
AWS.CognitoIdentity = require('aws-sdk/clients/cognitoidentity');
AWS.CognitoIdentityServiceProvider = require('aws-sdk/clients/cognitoidentityserviceprovider');
AWS.CognitoSync = require('aws-sdk/clients/cognitosync');
AWS.SQS = require('aws-sdk/clients/sqs');

module.exports = AWS;



//////////////////
// WEBPACK FOOTER
// ../scripts/aws.js
// module id = 15
// module chunks = 0